export const REQUIRED = 'Campo obrigatório.';
export const INVALID_CPF = 'CPF inválido.';
export const SAME_PASSWORD = 'As senhas devem ser iguais.';
export const INVALID_DATE = 'Data inválida.';
export const EMAIL_INVALID = 'Digite um email válido.';
